// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
    min-width: 600px;
    min-height: 200px;
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 8px 24px !important;
}

.button-gap { gap: 12px; }

.form-control { font-size: 14px; }

.error-message {
    padding: 12px;
    margin-bottom: 16px;
    background-color: #fff;
    color: #97002e;
    border-radius: 4px;
    border-left: 4px solid #97002e;
    font-size: 14px;
}

.form-row { gap: 20px; }

.form-row.three-col {
    display: grid;
    grid-template-columns: 1fr 1fr 140px;
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.form-group label { margin-bottom: 6px; }

.checkbox-row {
    margin-top: 12px;
    margin-bottom: 12px;
    gap: 24px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #0066b2;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/materials-qaqc/edit-material-dialog/edit-material-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,cAAc,SAAS,EAAE;;AAEzB,gBAAgB,eAAe,EAAE;;AAEjC;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA,YAAY,SAAS,EAAE;;AAEvB;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA,oBAAoB,kBAAkB,EAAE;;AAExC;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB","sourcesContent":["mat-dialog-content {\n    min-width: 600px;\n    min-height: 200px;\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n}\n\n.button-gap { gap: 12px; }\n\n.form-control { font-size: 14px; }\n\n.error-message {\n    padding: 12px;\n    margin-bottom: 16px;\n    background-color: #fff;\n    color: #97002e;\n    border-radius: 4px;\n    border-left: 4px solid #97002e;\n    font-size: 14px;\n}\n\n.form-row { gap: 20px; }\n\n.form-row.three-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr 140px;\n    gap: 16px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.form-group label { margin-bottom: 6px; }\n\n.checkbox-row {\n    margin-top: 12px;\n    margin-bottom: 12px;\n    gap: 24px;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: #0066b2;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
